<template>
  <div class="Header wrapper" :style="{height: height}">
    <!-- 背景内容 开始 -->
      <div class="title">
          <span v-if="tips" class="tip">如果您前方有人正在购买，强烈建议您等待，避免造成出货混乱！</span>
          <span v-if="tips == false && shopInfo.machine.name != ''">{{ shopInfo.machine.name }}</span>
          <span v-if="tips == false && shopInfo.machine.name == ''">{{ imei }}</span> 
      </div>
      <swiper v-if="head" :options="swiperOption">
        <swiper-slide v-for="(item,index) in headInfo" :key="index">
              <img :src="item.img"/>
        </swiper-slide>
        <div class="swiper-pagination"  slot="pagination"></div>
      </swiper> 
  </div>
</template>

<script>
// import Star from '../../components/star/Star'
export default {
  name: 'Header',
  data () {
    return {
      isShow:false,
      height: '20px',
      tips:true,
      swiperOption:{
        autoplay: { disableOnInteraction: false },
        pagination:{
          el:'.swiper-pagination',
          clickable:true,
        },
        loop:true,
      }
    }
  },
  components:{
     // "app-star":Star
  },
  props:{
    headInfo:{
      default:{}
    },
    shopInfo:{},
    imei:{
      String
    },
    head:{
      String
    }
  },
  created(){
    console.log('head')
    console.log(this.head)
    console.log(this.headInfo)
    console.log(this.height)
    if(this.head){
      this.height = '190px'
    }else{
      this.height = '20px'
    }
    var that = this
    setTimeout(function(){
      that.tips = false;
    },15000);
  },
  methods: {
    // HandleClick:function(item){
    //   if(item.url!=undefined && item.url !='null'){
    //     var answer = confirm("是否从当前页面跳转到广告链接？") //把确认框赋值给answer
    //     if(answer) {//判断是否点击确定
    //     window.location =item.url //确定的话游览器自身跳转
    //     }
    //   }
    // }
  },
  watch: {
    head:{
      handler: function (val, oldVal) { 
        console.log('header中的head值' + this.head)
        if(this.head){
          this.height = "190px"
        }else{
          this.height = "20px"
        }
      },
      deep: true
    }
  }
}
</script>


<style scoped>
/*@import url('../../common/css/style.css');*/
.wrapper >>>.swiper-pagination-bullet-active{
  background:#fff;
}
.wrapper{
  position: relative;
  overflow:hidden;
  width:100%;
  height:0;
  padding-bottom:32%;
}

.wrapper img{
  width:100%;
  height:160px;
}
.Header{
  width:100%;
  padding: 0 0 0 0;
  margin: auto;
}


.title{
  width:100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-top: 0px;
  font-size: 14px;
  color: #ffbb22;
  font-weight: bold;  
}

.tip {
    font-size: 14px;
    color: #696969;
    display: inline-block;
    white-space: nowrap;
    animation: 15s wordsLoop linear infinite normal ;
}

@keyframes wordsLoop {
    0% {
        transform: translateX(400px);
        -webkit-transform: translateX(400px);
    }
    100% {
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
}

@-webkit-keyframes wordsLoop {
    0% {
        transform: translateX(400px);
        -webkit-transform: translateX(400px);
    }
    100% {
        transform: translateX(-100%);
        -webkit-transform: translateX(-100%);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Header/Header.vue